import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdOnService from '../../api/services/AdOnService';
import MainPagetitle from '../../layouts/MainPagetitle';


const AddAdOns = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState()
  const [error, setError] = useState([]);
  const [icon, setIcon] = useState()

  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var ad_ons_image = fileReader.result
      setFile(ad_ons_image)
    }
  }
const onIconChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var ad_ons_icon = fileReader.result
      setIcon(ad_ons_icon)
    }
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
          "title": event.target.title.value,
          "ad_ons_icon": icon ? icon.split(',')[1] : "",
          "ad_ons_image":file ? file.split(',')[1] : "",
          "description": event.target.description.value,
          
      }
      let responseData = await AdOnService.store(userData).json()
      if (responseData.status === true) {
       
        navigate("/admin/ad_ons_equipments");
      }
    } catch (error) {
        console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
      }
    
  };

  return (
    <>
      <MainPagetitle mainTitle="Ad-Ons" pageTitle={'Ad-Ons'} parentTitle={'Home'} />
      <div className="container-fluid">
            <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                            <h4 className="card-title">Ad-Ons Equipments</h4>
                            </div>
                            <div className="card-body">
                                <form className="form-valide" onSubmit={onSubmitForm}>
                                <div className="row">
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Title<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" name='title' id="val-username" placeholder="" />

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                      <label htmlFor="val-number" className="form-label"> Ad-Ons Icon <span className="text-danger">*</span></label>
                                      <img className="img-drop-area" height={icon ? 100 : 0} width={icon ? 100 : 0} name="ad_ons_icon" src={icon} alt='' />
                                      <input type="file" className="form-control" name='ad_ons_icon' id="val-number" accept="image/png, image/jpeg" onChange={onIconChange} />
                                    </div>
                                    <div className="col-xl-12 mb-3">
                                      <label htmlFor="val-number" className="form-label"> Ad-Ons Image <span className="text-danger">*</span></label>
                                      <img className="img-drop-area" height={file ? 100 : 0} width={file ? 100 : 0} name="ad_ons_image" src={file} alt='' />
                                      <input type="file" className="form-control" name='ad_ons_image' id="val-number" accept="image/png, image/jpeg" onChange={onFileChange} />
                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label className="form-label" htmlFor="val-suggestions">Description <span className="text-danger">*</span></label>
                                        <textarea rows="3"  id="val-suggestions" className="form-control" name='description'></textarea>
                                    </div>
                                </div>
                                <h5 style={{color:'red'}}>{error}</h5>
                                <div>
                                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
           
            </div>
        
      </div>

    </>
  );
};
export default AddAdOns;